import {CommonModule} from '@angular/common';
import {Component, Input, Output, EventEmitter} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {AlertType, AlertIconType} from '../../interfaces/alert-type';

@Component({
  selector: 'genesis-alert-icon',
  templateUrl: './alert-icon.component.html',
  styleUrls: ['./alert-icon.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class AlertIconComponent {
  /**
   * Message label to be translated and displayed to the user
   */
  @Input() public messageLabel: string;

  @Input() public messageSubLabel: string;

  /**
   * Type of the alert to be displayed. Default: warning
   */
  @Input() public type: AlertType = AlertType.Warning;

  /**
   * Icon to be shown or hidden
   */
  @Input() public showIcon = true;

  @Input() public noBorder = false;

  @Input() public dismissible = false;

  @Input() public isSnackbar = false;

  @Input() public role = 'alert';

  @Output() public dismissEvent = new EventEmitter<void>();

  public iconTypes = AlertIconType;

  public isDismissed = false;

  public onDismiss(): void {
    this.isDismissed = true;
    this.dismissEvent.emit();
  }
}
